export default __webpack_public_path__ + "static/media/template-compraventa-automovil.49862e8b.jpg";